import { render, staticRenderFns } from "./DetailsPage.vue?vue&type=template&id=718302ce&scoped=true"
import script from "./DetailsPage.vue?vue&type=script&lang=js"
export * from "./DetailsPage.vue?vue&type=script&lang=js"
import style0 from "./DetailsPage.vue?vue&type=style&index=0&id=718302ce&prod&scoped=true&lang=css"
import style1 from "./DetailsPage.vue?vue&type=style&index=1&id=718302ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718302ce",
  null
  
)

export default component.exports